import { palette } from "../../../theme";
import Snackbar from "@mui/material/Snackbar";
import { styled } from "@mui/material/styles";

export const StyledSnackbar = styled(Snackbar, {
  shouldForwardProp: prop => prop !== "status",
})<{ status?: string }>(({ theme, status = "info" }) => ({
  "&&": {
    position: "absolute",
    left: "50%",
    right: "auto",
    top: "50%",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    zIndex: theme.zIndex.snackbar + 1,
  },
  "& .MuiPaper-root": {
    backgroundColor:
      status === "success"
        ? palette.success
        : status === "error"
        ? palette.error
        : status === "warning"
        ? palette.warning
        : palette.info,
  },
}));
